import { useCallback, useState } from 'react';
import type { ContentProfile } from '@content-planner/shared';
import { api, ApiClientError } from '../lib/api.js';

type Status = 'idle' | 'submitting' | 'success' | 'error';

type State = { status: Status; error: string | null; token: string | null };

const INITIAL: State = { status: 'idle', error: null, token: null };

export function useLeadCapture() {
  const [state, setState] = useState<State>(INITIAL);

  const submit = useCallback(
    async (args: { email: string; name?: string; profile: ContentProfile; month: string }) => {
      setState({ status: 'submitting', error: null, token: null });
      try {
        const res = await api.captureLead(args);
        setState({ status: 'success', error: null, token: res.token });
        return { ok: true as const, token: res.token };
      } catch (err) {
        const message =
          err instanceof ApiClientError
            ? err.message
            : 'We could not save your details. Try again in a moment.';
        setState({ status: 'error', error: message, token: null });
        return { ok: false as const, message };
      }
    },
    [],
  );

  return { ...state, submit };
}
